import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UltimosLotesCompletadosComponent } from './ultimos-lotes-completados/ultimos-lotes-completados.component';



const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'ultimos-lotes-completados',
        component: UltimosLotesCompletadosComponent,
        data: {
          title: "Últimos lotes completados",
          breadcrumb: "Últimos lotes completados"
        }
      },
      {
        path: 'ultimos-lotes-completados/:id',
        component: UltimosLotesCompletadosComponent,
        data: {
          title: "Últimos lotes completados",
          breadcrumb: "Últimos lotes completados"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UltimosLotesCompletadosRoutingModule { }
